export default __webpack_public_path__ + "static/media/send.de7a10de.png";